module.exports = __webpack_public_path__ + "static/media/19ESCAP40.4ea01903.jpg";